<template>
  <div class="settings">
    <h1 class="view__title">Settings</h1>
  </div>
</template>

<script>
export default {
  name: "settings"
};
</script>
